import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import FareTrendsUI from '@stencil/dstories/src/components/SRP/FareTrendsUI/FareTrendsUI';
import {
  flightSearchDataSelector,
  fareTrendsDataSelector,
  selectedFareIdentifierSelector,
  specialFareOptionsSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import { getPDTDetails } from '@stencil/flights-seo-reducers/src/utils/utils';
import getSrpUrl from '@stencil/flights-utils/src/get-srp-url';
import getProcessedFareTrendsData from '@stencil/flights-utils/src/get-processed-fare-data';
import { flightsSeoReducersPdtLoggingThunk } from '@stencil/flights-seo-reducers/src/utils/common-thunks';

const SeoSrpFareTrends = ({ getFareData }) => {
  useEffect(() => {
    getFareData('onward', true);
  }, []);

  const fareData = useSelector(fareTrendsDataSelector);
  const selectedFareIdentifier = useSelector(selectedFareIdentifierSelector);
  const fareOptionsInfo = useSelector(specialFareOptionsSelector);
  const flightSearchData = useSelector(flightSearchDataSelector);
  const { departure } = flightSearchData;

  const [fareTrendsData, setFareTrendsData] = useState(
    getProcessedFareTrendsData({
      date: null,
      departure,
      fareCalendarData: fareData
    })
  );

  useEffect(() => {
    setFareTrendsData(
      getProcessedFareTrendsData({
        date: null,
        departure,
        fareCalendarData: fareData
      })
    );
  }, fareData);

  const changeDateSelectedInFareTrends = selectedDate => {
    if (departure.yyyymmdd !== selectedDate) {
      let searchParams = '';
      if (selectedFareIdentifier) {
        const fareDetails = getPDTDetails(selectedFareIdentifier, fareOptionsInfo);
        const { pdt_details } = fareDetails || {};
        flightsSeoReducersPdtLoggingThunk({ ...pdt_details });
        searchParams = `&${selectedFareIdentifier}`;
      }
      window.location.href = getSrpUrl(
        { ...flightSearchData, departure: { yyyymmdd: selectedDate } },
        searchParams
      );
    }
  };

  const fareCalendarNextPreviousClick = isNext => {
    const data = getProcessedFareTrendsData({
      date: isNext ? fareTrendsData[fareTrendsData.length - 1].date : fareTrendsData[0].date,
      departure,
      fareCalendarData: fareData
    });
    setFareTrendsData(data);
  };

  if (!fareTrendsData || !fareTrendsData.length) {
    return null;
  }

  return (
    <FareTrendsUI
      fareTrendsData={fareTrendsData}
      changeDateSelectedInFareTrends={changeDateSelectedInFareTrends}
      departure={departure}
      fareCalendarNextPreviousClick={fareCalendarNextPreviousClick}
    />
  );
};

export default SeoSrpFareTrends;
